import { Helmet } from "react-helmet";

const galleryImages = [
  {
    src: "https://images.pexels.com/photos/7479545/pexels-photo-7479545.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Dudak Dolgusu Sonucu - Doğal ve dolgun dudaklar",
  },
  {
    src: "https://images.pexels.com/photos/3373716/pexels-photo-3373716.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Botoks Sonucu - Pürüzsüz ve genç görünümlü cilt",
  },
  {
    src: "https://images.pexels.com/photos/9038626/pexels-photo-9038626.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "PRP Sonucu - Parlak ve canlı cilt",
  },
  {
    src: "https://images.pexels.com/photos/3861592/pexels-photo-3861592.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Mezoterapi Sonucu - Sağlıklı ve aydınlık cilt",
  },
  {
    src: "https://images.pexels.com/photos/185480/pexels-photo-185480.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Cilt Gençleştirme - Doğal güzellik",
  },
  {
    src: "https://images.pexels.com/photos/17217644/pexels-photo-17217644.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Estetik Sonuç - Yumuşak ve bakımlı cilt",
  },
];

function Gallery({ onImageClick }) {
  return (
    <section id="gallery">
      <Helmet>
        <title>
          Medikal Estetik Galeri | Örnek Çalışmalar | Dr. Tayfun Giyik
        </title>
        <meta
          name="description"
          content="Dr. Tayfun Giyik'in medikal estetik alanındaki çalışmalarından örnekler. Doğal ve estetik sonuçlar."
        />
        <link rel="canonical" href="https://www.drtayfungiyik.com.tr/galeri" />
        <meta property="og:title" content="Medikal Estetik Galeri" />
        <meta
          property="og:description"
          content="Doğal estetik sonuçların galerisi."
        />
      </Helmet>
      <h2 className="section-title">Doğal Sonuçlar</h2>
      <p style={{ textAlign: "center", marginBottom: "2rem", color: "#666" }}>
        (Örnek görseller - Mahremiyet ilkesi gereği hasta fotoğrafları
        paylaşılmamaktadır.)
      </p>
      <div className="gallery-grid">
        {galleryImages.map((image, index) => (
          <div
            className="gallery-item"
            key={index}
            onClick={() => onImageClick(image.src)}
          >
            <img src={image.src} alt={image.alt} />
            <div className="gallery-caption">{image.alt.split(' - ')[0]}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Gallery;
